export const guidelinesUrl = 'https://ovpr.uconn.edu/services/research-development/faculty-travel'
